// import BaseTable from 'antd/lib/table/Table'
import BaseTable, {
  ColumnsType,
  TableProps as BaseTableProps,
} from 'antd/lib/table'

export interface TableProps<RecordType> extends BaseTableProps<RecordType> {}

export type { ColumnsType }

/* eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any */
export function Table<RecordType extends object = any>(
  props: TableProps<RecordType>
): JSX.Element {
  return (
    <>
      <BaseTable<RecordType> {...props} />
    </>
  )
}

export default Table
